import React from 'react';
import HBLogo from 'dataModule/assets/img/HealthBeatsLogo.svg';

export default ({ width = 104, height = 104, ...props }) => <img src={HBLogo} width={width} height={height} {...props} />;
